export default function CalendarBackground() {
  const weekDates = [
    { day: "Sun", date: 1, fullDay: "Sunday", tasks: null },
    { day: "Mon", date: 2, fullDay: "Monday", tasks: null },
    { day: "Tue", date: 3, fullDay: "Tuesday", tasks: "0/4 tasks completed", isSelected: true },
    { day: "Wed", date: 4, fullDay: "Wednesday", tasks: "1/3 tasks completed" },
    { day: "Thu", date: 5, fullDay: "Thursday", tasks: "0/4 tasks completed" },
    { day: "Fri", date: 6, fullDay: "Friday", tasks: null },
    { day: "Sat", date: 7, fullDay: "Saturday", tasks: null },
  ]

  const tasks = [
    {
      assignee: "@Daniel Bailey",
      title: "Inverse mission-critical array with @Sandra Corkery",
      description: "More info on this task: visualize ubiquitous users",
    },
    {
      assignee: "@Daniel Bailey",
      title: "Down-sized background groupware with @Roxy Wyman",
      description: "More info on this task: aggregate distributed schemas",
    },
    {
      assignee: "@Daniel Bailey",
      title: "Implemented dynamic methodology with @Julio Thiel",
      description: "More info on this task: enable intuitive networks",
    },
    {
      assignee: "@Daniel Bailey",
      title: "Monitored incremental circuit with @Nancey Zieme",
      description: "More info on this task: target killer architectures",
    },
  ]

  return (
    <div className="flex h-full">
      <div className="flex h-full w-[60%] flex-1 flex-col">
        <div className="flex items-center justify-between border-b p-4">
          <div className="flex items-center gap-4">
            <button className="text-muted-foreground">←</button>
            <button className="text-muted-foreground">→</button>
            <h2 className="text-lg font-medium">Jun 1 - 7</h2>
          </div>
          <div className="flex items-center gap-2">
            <button className="bg-muted rounded px-3 py-1 text-sm">Weekly</button>
            <span className="text-muted-foreground">▼</span>
          </div>
        </div>
        <div className="grid grid-cols-7 border-b">
          {weekDates.map((day, index) => (
            <div key={index} className="flex flex-col items-center border-r p-3 last:border-r-0">
              <div className="text-muted-foreground mb-1 text-xs">{day.day}</div>
              <div className={`rounded px-2 py-1 text-sm font-medium ${day.isSelected ? "bg-muted" : ""}`}>
                {day.date}
              </div>
            </div>
          ))}
        </div>
        <div className="flex-1 overflow-auto">
          {weekDates.map((day, index) => (
            <div key={index} className="flex flex-col">
              <div className="bg-muted/50 flex items-center justify-between gap-2 border-b px-4 py-2">
                <div className="flex items-center gap-2">
                  <p className="text-muted-foreground text-sm">{day.fullDay}</p>
                  <h3 className="text-sm font-semibold">June {day.date}</h3>
                </div>
                <div className="flex items-center gap-2">
                  {day.tasks && <div className="bg-background rounded border px-2 py-1 text-xs">{day.tasks}</div>}
                </div>
              </div>
              <div className="flex h-24 items-center justify-center border-b">
                <p className="text-muted-foreground text-sm">No events scheduled</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="w-[40%] border-l">
        <div className="border-b p-4">
          <h3 className="font-medium">Tasks due Tuesday, Jun 3</h3>
        </div>

        <div className="space-y-4 p-4">
          {tasks.map((task, index) => (
            <div key={index} className="space-y-3 rounded-lg border p-4">
              <div className="space-y-2">
                <div className="text-sm">
                  <span className="text-muted-foreground">{task.assignee}</span>
                  <span className="ml-1 font-medium">{task.title}</span>
                </div>
                <div className="text-muted-foreground text-xs">{task.description}</div>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <input type="checkbox" className="rounded" />
                  <button className="bg-muted rounded px-3 py-1 text-xs">Mark as complete</button>
                </div>
                <div className="flex items-center gap-2">
                  <span className="bg-muted rounded px-2 py-1 text-xs">Today</span>
                  <div className="bg-muted flex h-6 w-6 items-center justify-center rounded-full">
                    <span className="text-xs">DB</span>
                  </div>
                  <span className="text-xs font-medium">Daniel Bailey</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
